import { Typography } from "@lyfegen-platform/react-common";
import { useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const TasksPlaceholder: React.FC = () => {
	const { t } = useTranslation();
	const { spacing } = useTheme();

	return (
		<Typography style={{ marginTop: spacing(2), marginLeft: spacing(2) }} variant="subtitle2" color="textSecondary">
			{t("no-notification")}
		</Typography>
	);
};
export default TasksPlaceholder;
